import { z } from 'zod'

export const PiloteCentralRoleRecordZod = z.object({
  id: z.number(),
  label_fr: z.string(),
  label_en: z.string(),
  description_fr: z.string().nullable(),
  description_en: z.string().nullable(),
  display_rank: z.number(),
  active: z.boolean(),
  version: z.number(),
})
export type PiloteCentralRoleRecord = z.infer<typeof PiloteCentralRoleRecordZod>

export const PiloteCentralOfferedRoleZod = PiloteCentralRoleRecordZod.extend({
  legacy_code: z.string().nullable(),
})
export type PiloteCentralOfferedRole = z.infer<typeof PiloteCentralOfferedRoleZod>
